<!-- Screen for select-icon -->
  <ng-container>
  <wms-dialog-header  (onClose)="onClose()" class="wm-select-icon-dialog medium wm-studio-dialog" [title]="locale.LABEL_SELECT_ICON_DIALOG_TITLE"   ></wms-dialog-header>
  <wms-dialog-body>
    <div class="content-container full-height">
      <tabset class="wm-tabs full-height" active="activeTabIndex">

        <tab *ngFor="let iconFamily of iconFamilies;   index as $index"
                 [active]="iconFamily.render"
                 (selectTab)="renderIconFamily($index);" index ="$index">
          <ng-template tabHeading>
          <span class="tab-heading">{{iconFamily.name}}</span>
            </ng-template>
          <section class="full-height"  >
            <div class="primary-panel">
              <div class="wm-select-icon-filter-container row">
                <div class="col-sm-5">
                  <select [(ngModel)]="iconFamily.selectedCategory.name"
                          (change)="selectIconCategory(iconFamily)"
                          class="form-control">
                  <option  *ngFor="let category of iconFamily.categories; index as index ">{{category.name}}</option>
                          </select>


                </div>
                <div class="col-sm-5 input-group">
                  <input type="text" [(ngModel)]="iconSearchText" placeholder="{{locale.MESSAGE_PLACEHOLDER_SEARCH_ICONS}}"
                         class="form-control app-textbox">
                  <span class="input-group-addon">
                    <i class="wms wms-search"></i>
                  </span>
                </div>
              </div>
              <div class="wm-select-icon-list-container">
                <ul class="list-inline icon-list">
                  <li class="wm-icon-option" [ngClass]="{selected: iconFamily.prefix + icon === selectedIcon.name}"
                      title="{{iconFamily.prefix + icon}}"
                      *ngFor="let icon of iconFamily.selectedCategory.icons | filter:'':iconSearchText "
                      (click)="selectIcon(iconFamily.prefix + icon)">
                    <span class="wm-icon-preview {{iconFamily.prefix + icon}}"></span>
                    <span class="wm-icon-name">{{icon}}</span>
                  </li>
                </ul>
              </div>
            </div>
            <div class="secondary-panel">
              <div class="wm-select-icon-preview">
                <h4>{{locale.LABEL_ICON_PREVIEW}}</h4>
                <div class="row icon-preview">
                  <span class="{{selectedIconExpr}}"></span>
                </div>
                <div class="icon-properties">
                  <div class="row">
                    <div class="col-md-5">
                      <label class="control-label app-label">{{locale.LABEL_ICON_PROPERTY_SIZE}}</label>
                    </div>
                    <div class="col-md-7">
                      <select [(ngModel)]="selectedIcon.size" class="form-control" (change)="onIconPropertyChange('size')">
                        <option value=""></option>
                        <option value="fa-lg">lg</option>
                        <option value="fa-2x">2x</option>
                        <option value="fa-3x">3x</option>
                        <option value="fa-4x">4x</option>
                        <option value="fa-5x">5x</option>
                      </select>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-5">
                      <label class="control-label app-label">{{locale.LABEL_ICON_PROPERTY_ROTATE}}</label>
                    </div>
                    <div class="col-md-7">
                      <select [(ngModel)]="selectedIcon.rotate" class="form-control" (change)="onIconPropertyChange('rotate')" [disabled]="selectedIcon.flip">
                        <option value=""></option>
                        <option value="fa-rotate-90">90</option>
                        <option value="fa-rotate-180">180</option>
                        <option value="fa-rotate-270">270</option>
                      </select>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-5">
                      <label class="control-label app-label">{{locale.LABEL_ICON_PROPERTY_FLIP}}</label>
                    </div>
                    <div class="col-md-7">
                      <select [(ngModel)]="selectedIcon.flip" class="form-control" (change)="onIconPropertyChange('flip')" [disabled]="selectedIcon.rotate">
                        <option value=""></option>
                        <option value="fa-flip-horizontal">{{locale.LABEL_HORIZONTAL}}</option>
                        <option value="fa-flip-vertical">{{locale.LABEL_VERTICAL}}</option>
                      </select>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-5">
                      <label class="control-label app-label">{{locale.LABEL_ICON_PROPERTY_ANIMATION}}</label>
                    </div>
                    <div class="col-md-7">
                      <select [(ngModel)]="selectedIcon.animation" class="form-control" (change)="onIconPropertyChange('animation')">
                        <option value=""></option>
                        <option value="fa-spin">{{locale.LABEL_SPIN}}</option>
                        <option value="fa-pulse">{{locale.LABEL_PULSE}}</option>
                      </select>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-5">
                      <label class="control-label app-label">{{locale.LABEL_ICON_PROPERTY_PULL}}</label>
                    </div>
                    <div class="col-md-7">
                      <select [(ngModel)]="selectedIcon.pull" class="form-control" (change)="onIconPropertyChange('pull')">
                        <option value=""></option>
                        <option value="fa-pull-right">{{locale.LABEL_RIGHT}}</option>
                        <option value="fa-pull-left">{{locale.LABEL_LEFT}}</option>
                      </select>
                    </div>
                  </div>
                  <div class="row form-group-checkbox">
                    <div class="col-md-5">
                      <label class="control-label app-label">{{locale.LABEL_ICON_PROPERTY_FIXEDWIDTH}}</label>
                    </div>
                    <div class="col-md-7">
                      <input type="checkbox" [(ngModel)]="selectedIcon.fixedWidth" (change)="onIconPropertyChange('fixedWidth')"
                             ng-true-value="'fa-fw'"/>
                    </div>
                  </div>
                  <div class="row form-group-checkbox">
                    <div class="col-md-5">
                      <label class="control-label app-label">{{locale.LABEL_ICON_PROPERTY_BORDER}}</label>
                    </div>
                    <div class="col-md-7">
                      <input type="checkbox" [(ngModel)]="selectedIcon.border" [checked]="onIconPropertyChange('border')"
                             ng-true-value="'fa-border'"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </tab>
      </tabset>
      <button class="importFontBtn" (click)="openResourceDialog()">Import Icon font</button>
    </div>
  </wms-dialog-body>
    <wms-dialog-footer>
      <button class="button-secondary btn app-button" title="{{locale.LABEL_CANCEL}}" (click)="onClose()" name="wm-select-icon-cancel">{{locale.LABEL_CANCEL}}</button>
      <button class="button-primary btn app-button" title="{{locale.LABEL_APPLY}}" (click)="saveIcon()" name="wm-select-icon-apply">{{locale.LABEL_APPLY}}</button>
    </wms-dialog-footer>
  </ng-container>


